
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTrashCan,
  faPenToSquare,
  faArrowUp,
  faArrowDown
} from '@fortawesome/pro-solid-svg-icons'
import { faCommentDots as faCommentOutline } from '@fortawesome/pro-regular-svg-icons'

import { useStyles, blockHighlight } from './block-actions.style'

const AVAILABLE_ACTIONS = ['moveUp', 'moveDown', 'comment', 'edit', 'delete']
const ACTIONS_ICON_MAP = {
  moveUp: faArrowUp,
  moveDown: faArrowDown,
  comment: faCommentOutline,
  edit: faPenToSquare,
  delete: faTrashCan
}

export const BlockActions = function ({ blockKey, enabled, showHighlight, actions = {}, children, ...props }) {
  const classes = useStyles({ enabled, showHighlight })

  return (
    <div
      className={classes.actionsWrapper}
      data-block-key={blockKey}
      {...props}
    >

      {/* Actions Bar */}
      <div className={classes.actionsArea}>
        {/* Extend the hover zone for the action area - prevents losing hover when mouse takes a diagonal path */}
        <div className="block-actions-hover-extend" />
        <div className="block-actions">
          {AVAILABLE_ACTIONS.map((action) => {
            if (actions[action] && !actions[action].disabled) {
              return (
                <FontAwesomeIcon
                  icon={ACTIONS_ICON_MAP[action]}
                  onClick={actions[action].onClick}
                  data-qa={`${action}-block-button`}
                  key={action}
                />
              )
            } else {
              return null
            }
          })}
        </div>
      </div>

      {/* Inner contents */}
      <div className={classes.innerWrapper} style={showHighlight ? blockHighlight : {}}>
        {children}
      </div>
    </div>
  )
}
